var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
var defaultPlaceholderStyles = {
    height: 36,
    width: 36,
    backgroundColor: "transparent",
    borderColor: "white",
    borderRadius: "50%",
    borderStyle: "solid",
    borderWidth: "1px",
    display: "inline-block",
    fontSize: 14,
    cursor: "pointer",
    color: "white",
};
/**
 * A lightweight static placeholder component for the Me Control
 * @param param0 Properties for this component
 * @param param0.onClick The handler that should be invoked when the placeholder is clicked. Usually this will load and then render the full Me Control
 * @param param0.placeholderStyles The styles to apply to the placeholder
 * @param param0.initials The initials to display in the placeholder
 * @returns An instance of this component
 */
export var MeControlPlaceholder = function MeControlPlaceholder(_a) {
    var onClick = _a.onClick, placeholderStyles = _a.placeholderStyles, initials = _a.initials;
    return (React.createElement("button", { type: "button", onClick: onClick, style: __assign(__assign({}, defaultPlaceholderStyles), placeholderStyles) },
        React.createElement("span", null, initials)));
};
